import { useEffect, useState } from 'react'
import { ReplaySubject, Subject } from 'rxjs'
import { generateRandomString } from '@src/utils/functions'

export const seedUsed = new Subject<void>()
export const nextServerSeedHash = new ReplaySubject<string>()

export const ProvablyFairComponent = () => {
  const [, setHash] = useState<string>()

  let seed = localStorage.getItem('next_seed')
  if (null === seed) {
    seed = generateRandomString(40)
    localStorage.setItem('next_seed', seed)
  }

  useEffect(() => {
    const obs = nextServerSeedHash.subscribe((hash) => {
      setHash(hash)
    })

    return () => {
      obs.unsubscribe()
    }
  }, [])
}

export default ProvablyFairComponent
